const DownArrow = () => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none">
<path d="M13.2754 0.999924L7.13784 7.1595L1.00028 0.999924M2.02321 12.2925H12.2525" stroke="#395E48"/>
</svg>
    )
}
export default DownArrow;